// extracted by mini-css-extract-plugin
export default {"active":"CustomDots_active__sz6XV","inactive":"CustomDots_inactive__JbGie"};